<template>
    <BaseSection>
        <TheQuote
            :quote-text="quoteText"
            :caption-text="captionText"
        />
    </BaseSection>
</template>

<script setup>
defineProps({
    quoteText: {
        type: String,
        required: true,
        default: null
    },
    captionText: {
        type: String,
        default: null
    }
});
</script>
